import { render, staticRenderFns } from "./admin-search-rest-api-reference.vue?vue&type=template&id=52611a57&scoped=true&"
import script from "./admin-search-rest-api-reference.vue?vue&type=script&lang=js&"
export * from "./admin-search-rest-api-reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52611a57",
  null
  
)

export default component.exports